export class AtlasPatologiaModel {
    especialidades: Array<string>;
    especialidade: string;
    search: string;
    estudos: Array<Patologia>
}

export class Patologia {
    titulo: string;
    eNovo: boolean;
    descricao: string;
    tipo: string;
    link: string;
    images: Array<string>;
}


// WEBPACK FOOTER //
// ./src/pages/atlas-patologia/atlas-patologia.modelview.ts